import { useEffect, useRef, useState, useMemo } from 'react';
import rgbHex from 'rgb-hex';
import { SketchPicker } from 'react-color';
import { confirmAlert } from 'react-confirm-alert'; 
import DeleteIcon from '../../../components/icons/delete-icon';
import PencilIcon from '../../../components/icons/pencil-icon';
import SelectField from '../../../components/Input/select-field';
import ReactSelectField from '../../../components/Input/react-select-field';

const Row = ({ lexicon, updateStratigraphyLexicon, addStratigraphyLexicon, deleteAddingRow, deleteStratigraphyLexicon, allStratigraphyLexicons }:any) => {

    const [editMode, setEditMode] = useState(false);
    const [description, setDescription] = useState("");
    const [color, setColor] = useState<any>();
    const [codeError, setCodeError] = useState(false);
    const [displayLineColorPicker, setDisplayLineColorPicker] = useState(false);
    const [alternativeId, setAlternativeId] = useState<any>();

    const descriptionRef = useRef<any>();

    useEffect(() => {
        if (lexicon) {    
            setDescription(lexicon.description);
            setColor(lexicon.color);            
            setAlternativeId(lexicon.alternativeIds && lexicon.alternativeIds.length > 0 ? lexicon.alternativeIds[0] : null);
        }
    },
    [lexicon]);

    const handleLineColorClick = () => {
        if (!color) {
            setColor('#ffffff'); // Default to white if no color is set
        }
        setEditMode(true);
        setDisplayLineColorPicker(!displayLineColorPicker);
    };

    const handleLineColorClose = () => {
        setDisplayLineColorPicker(false);
        setEditMode(false);
        setColor(lexicon.color || '#ffffff');
    };

    useEffect(() => {
        if (lexicon?.editMode) {
            setEditMode(true);            
        }
    },
    [lexicon?.editMode]);

    useEffect(() => {        
        if (editMode && descriptionRef.current) {
            if (document.activeElement !== descriptionRef.current) {
                descriptionRef.current.focus();
            }            
        }
    },
    [editMode, descriptionRef?.current]);

    const onEdit = () => {
        setCodeError(false);
        setEditMode(true);
    };

    const onChangeFillColor = (value: any) => {
        setColor(convertToHex(value));
    };

    const convertToHex = (value: any) => {      
        return "#" + rgbHex(value.rgb.r, value.rgb.g, value.rgb.b, value.rgb.a);
      };
    const onChangeDescription = (newCode: string) => {
        setDescription(newCode);
    }

    const onSave = () => {
        setCodeError(false);     
        const alternativeIds = alternativeId ? [alternativeId] : [];        
        if (lexicon.id) {
            updateStratigraphyLexicon({ ...lexicon, description, color, alternativeIds })
                .unwrap()
                .then(() => { 
                    setEditMode(false); 
                    setDisplayLineColorPicker(false);
                })
                .catch(() => { setCodeError(true); });
        } else {
            addStratigraphyLexicon({ description, color, alternativeIds })
                .unwrap()
                .then(() => { 
                    setEditMode(false); 
                    setDisplayLineColorPicker(false);
                })
                .catch(() => { setCodeError(true); });
        }
    }

    const onCancel = () => {        
        setEditMode(false);
        setDisplayLineColorPicker(false);
        setColor(lexicon.color || '#ffffff');
        if (!lexicon.id) {
            deleteAddingRow();
        } else {            
            setDescription(lexicon.description);
        }
    }

    const onDelete = () => {
        confirmAlert({
            title: 'Confirm Delete Stratigraphy Lexicon',
            message: `Are you sure you want to delete ${description}?`,
            buttons: [
              {
                label: 'Yes',
                onClick: () => {
                  deleteStratigraphyLexicon(lexicon.id);
                }
              },
              {
                label: 'No',
                onClick: () => {}
              }
            ]
          });
    }

    const allStratigraphyLexiconsOptions = useMemo(() => {
        return allStratigraphyLexicons
            .filter((item:any) => item.id !== lexicon.id)
            .map((item: any) => ({ value: item.id, label: item.description }));
    }, [allStratigraphyLexicons, lexicon.id]);

    return (    
        <tr className='editable-row'>                            
            <td>{editMode && <input type="text" placeholder="Description" ref={descriptionRef} className={`input`} value={description} onChange={(e) => onChangeDescription(e.target.value)} />} {!editMode && <p>{description}</p>}</td>
            <td>
                {editMode && <ReactSelectField 
                                    options={allStratigraphyLexiconsOptions} 
                                    onChange={(selectedOption: any) => setAlternativeId(selectedOption ? selectedOption.value : null)} 
                                    value={alternativeId} 
                                    readOnly={!editMode}
                                    includeEmptyOption={true} /> }
                {!editMode && <p>{alternativeId ? allStratigraphyLexicons.find((item:any) => item.id === alternativeId)?.description : ""}</p>}
            </td>
            <td><div className='lookup-color-inline-edit' style={{backgroundColor: color}} onClick={handleLineColorClick}></div> <span className='color-code' onClick={handleLineColorClick}>{color}</span>
                                { displayLineColorPicker ? <div className='lookup-color-select'>                     
                                 <SketchPicker color={ color } onChangeComplete={onChangeFillColor} width={"200px"}/>
                               </div> : null }                
                            </td>
            <td>
                {!editMode && <span className='edit-icons'><PencilIcon className="icon" style={{width: "20px"}} onClick={onEdit} /> <DeleteIcon className="icon" style={{width: "20px"}} onClick={onDelete} /> </span>}
                {editMode && <div className="row-buttons">
                    <button className='button is-primary mr-2' onClick={onSave}><span className="icon"><i className="fas fa-check" title="Ok" aria-hidden="true"></i></span></button>
                    <button className='button' onClick={onCancel}><i className="fas fa-times" title="Ok" aria-hidden="true"></i></button>
                </div>}
            </td>
        </tr>           
    )    
};

export default Row;